/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Injectable, Inject } from "@angular/core";

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(ActivityRemarksDataService.Id, ActivityRemarksDataService);

    ActivityRemarksDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class ActivityRemarksDataService extends base.BaseDataService<Nema.Crew.Model.ActivityRemark> implements IActivityRemarkDataService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "activityRemarkDataService";

    public get EntityName(): string {
        return "ActivityRemark";
    }

    public get EntitiesName(): string {
        return "ActivityRemarks";
    }

    public getSome(workPlaceId: number): ng.IPromise<Nema.Crew.Model.ActivityRemark[]> {

        var self = this;

        var entityQuery = self.createEntityQuery()
            .where("WorkplaceId", "==", workPlaceId)
            .orderBy("Day asc")
            .using(this.entityManager);

        var promise = entityQuery.execute()
            // ignore remote query results and chain to local query. Discarded the query results ... but items remain in cache
            .then(() => {
                self.entityCollection = entityQuery.using(self.breeze.FetchStrategy.FromLocalCache).executeLocally();
                return <Nema.Crew.Model.ActivityRemark[]><any>self.entityCollection;
            });

        return promise;
    }

    public newActivityRemark(ar: Nema.Crew.Model.ActivityRemark) {
        this.entityManager.createEntity('ActivityRemark', <Nema.Crew.Model.ActivityRemark>{
            Day: ar.Day,
            Remark: ar.Remark,
            PersonId: ar.PersonId,
            Person: ar.Person,
            WorkplaceId: ar.WorkplaceId,
            Workplace: ar.Workplace
        });
    }
}

export interface IActivityRemarkDataService extends base.IDataService<Nema.Crew.Model.ActivityRemark> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/activityremarks.dataservice.ts